import script from "./TressGoogleMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressGoogleMap.vue?vue&type=script&lang=ts&setup=true"

import "./TressGoogleMap.vue?vue&type=style&index=0&id=83749a6a&lang=scss"

const __exports__ = script;

export default __exports__